import { render, staticRenderFns } from "./Etapa5.vue?vue&type=template&id=0505ae75&scoped=true"
import script from "./Etapa5.vue?vue&type=script&lang=js"
export * from "./Etapa5.vue?vue&type=script&lang=js"
import style0 from "./Etapa5.vue?vue&type=style&index=0&id=0505ae75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0505ae75",
  null
  
)

export default component.exports